import React from "react";
import { View } from "react-native";
import { useBiblo } from "../../hooks/Biblo.hook";
import { Typography } from "../Typography.component";
import { getTextStyles, getViewStyles } from "../../helpers/getStyles.helper";
import { ErrorBoundary } from "../ErrorBoundary.component";
export const IndexSectionHeader = _ref => {
  let {
    title,
    itemsCount
  } = _ref;
  const {
    indexOptions,
    defaultStyles,
    disableDefaultStyles: disableDefaultStylesGlobal,
    textParser
  } = useBiblo();
  const disableDefaultStyles = disableDefaultStylesGlobal || indexOptions.disableDefaultStyles;
  const Container = indexOptions.sectionHeaderComponent || View;
  return itemsCount ? /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "sectionHeaderComponent"
  }, /*#__PURE__*/React.createElement(Container, {
    title: title,
    style: getViewStyles([{
      height: indexOptions.sectionListItemHeight || 40
    }, indexOptions.sectionHeaderStyle], {
      paddingHorizontal: defaultStyles.spacing,
      backgroundColor: defaultStyles.surfaceColor,
      justifyContent: "center"
    }, disableDefaultStyles),
    textStyle: indexOptions.sectionHeaderTextStyle
  }, /*#__PURE__*/React.createElement(Typography, {
    bold: true,
    disableDefaultStyles: disableDefaultStyles,
    style: indexOptions.sectionHeaderTextStyle
  }, textParser(title, {
    type: "title",
    screen: "index",
    scope: "section",
    style: getTextStyles(indexOptions.sectionHeaderTextStyle, {
      fontWeight: "bold"
    }, disableDefaultStyles)
  })))) : null;
};
//# sourceMappingURL=IndexSectionHeader.component.js.map